import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery'
require("../../Content/Less/rangeDatePickerStyles.css");
/* if you will adjust datepicker settings ->
	read the docs and eat your vegestables bro !
https://bootstrap-datepicker.readthedocs.org/en/latest/options.html*/
require('bootstrap-datepicker')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.da.js')

class DatePickerRange extends Component {
    componentDidMount() {
        this.$rangePicker = $(this.refs.range);
        this.$rangePicker.datepicker({
            inputs: $('.range-start, .range-end'),
            format: 'DD d MM yyyy',
            autoclose: true,
            language: 'da-DA',
            calendarWeeks: true,
            todayHighlight: false,
            weekStart: '1',
        })

        $(this.refs.start).datepicker('setDate', this.props.dates.start ? new Date(this.props.dates.start) : '');
        $(this.refs.end).datepicker('setDate', this.props.dates.end ? new Date(this.props.dates.end) : '');
        this.$rangePicker.on('changeDate', this.onDatepickerChange);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.dates.key !== nextProps.dates.key) {
            this.$rangePicker.off('changeDate');
            $(this.refs.start).datepicker('setDate', nextProps.dates.start ? new Date(nextProps.dates.start) : '');
            $(this.refs.end).datepicker('setDate', nextProps.dates.end ? new Date(nextProps.dates.end) : '');
            this.$rangePicker.on('changeDate', this.onDatepickerChange);
        }
    }

    componentWillUnmount = () => {
        this.$rangePicker.datepicker('remove');
    };

    onDatepickerChange = () => {
        let start = $(this.refs.start).datepicker('getDate');
        let end = $(this.refs.end).datepicker('getDate');
        this.props.onChange(start, end);
    };

    calendarStart = () => {
        $(this.refs.start).datepicker("show");
    };

    calendarEnd = () => {
        $(this.refs.end).datepicker("show");
    };

    render() {
        return (
            <div
                className="input-daterange"
                style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}
                ref="range"
            >
                <div style={styles.text}> Start </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                >
                    <input
                        type="text"
                        placeholder="Vælg dato"
                        className="input-sm form-control range-start"
                        style={styles.inputs}
                        ref="start"
                    />
                    <i
                        className="fa fa-calendar waves-icon"
                        onClick={this.calendarStart}
                        style={styles.icon}
                        aria-hidden="true">
                    </i>
                </div>
                <div style={styles.text}> Slut </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                    <input
                        type="text"
                        placeholder="Vælg dato"
                        className="input-sm form-control range-end"
                        style={styles.inputs}
                        ref="end"
                    />
                    <i
                        className="fa fa-calendar waves-icon"
                        onClick={this.calendarEnd}
                        style={styles.icon}
                        aria-hidden="true"></i>
                </div>
            </div>
        );
    }
}

var styles = {
    inputs: {
        textAlign: 'left',
        height: '35px',
        borderRadius: '2px'
    },
    text: {
        fontSize: '12px'
    },
    periode: {
        height: '52px',
        lineHeight: '69px',
    },
    icon: {
        fontSize: '20px',
        marginLeft: '10px',
        height: '30px',
        width: '30px',
        lineHeight: '30px'
    }
}

DatePickerRange.propTypes = {
    onChange: PropTypes.func.isRequired
};

export default DatePickerRange



// WEBPACK FOOTER //
// ./src/App/Common/datepickerRange2.jsx